'use client';

import { Autocomplete, TextField } from '@mui/material';
import React from 'react';

const getTaxOptions = (taxOptions, number) => {
	const filterTaxes = taxOptions.filter(({ taxNumber }) => taxNumber === number);
	return filterTaxes.map(({ id, name }) => ({
		key: id,
		value: name,
	}));
};

const getTaxValue = (selectedTax): { key: string; value: string } => {
	if (!selectedTax) return { key: '', value: '' };
	return {
		key: selectedTax.id,
		value: selectedTax.name,
	};
};

export const TaxTableTaxesAutoComplete = ({ id, taxTableTaxes, selectedTax, taxNumber, handleChange }) => (
	<Autocomplete
		className='pca__rateFormForm-taxTableTaxesAutocomplete'
		options={getTaxOptions(taxTableTaxes, taxNumber)}
		value={getTaxValue(selectedTax)}
		freeSolo
		disabled={false}
		size='medium'
		isOptionEqualToValue={(option, value) => option.key === value.key}
		getOptionLabel={(option) => {
			if (typeof option === 'string') return '';
			return option.value;
		}}
		renderOption={(props, option) => (
			<li {...props} key={`${id}-${option.key}`}>
				{option.value}
			</li>
		)}
		renderInput={(params) => (
			<TextField {...params} value={selectedTax?.id || ''} inputProps={{ ...params.inputProps, 'data-cy': id }} />
		)}
		onInputChange={(_, __, reason) => {
			if (reason === 'clear') handleChange(null);
		}}
		onChange={(_, value) => {
			if (!value || typeof value === 'string') return;
			const findSelection = taxTableTaxes.find((bp) => bp.id === value.key);
			handleChange(findSelection);
		}}
	/>
);
